import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';

import { MinistrySignUpComponent } from './ministry-sign-up.component';

const routes: Routes = [
  { path: 'ministry-sign-up', component: MinistrySignUpComponent },
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule],
})
export class MinistrySignUpRoutingModule {}
